"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setColumnFilter = exports.setSearchString = exports.setOrderBy = exports.clear = exports.toggleModal = void 0;
const ActionTypes = require("../../actionTypes/sokosite/configModal");
function toggleModal() {
    return {
        type: ActionTypes.TOGGLE_MODAL
    };
}
exports.toggleModal = toggleModal;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
function setOrderBy(orderBy, order) {
    return {
        type: ActionTypes.SET_ORDER_BY,
        payload: {
            orderBy,
            order
        }
    };
}
exports.setOrderBy = setOrderBy;
function setSearchString(data, project) {
    return {
        type: ActionTypes.SET_SEARCH_STRING,
        payload: data,
        project
    };
}
exports.setSearchString = setSearchString;
function setColumnFilter(field, value) {
    return {
        type: ActionTypes.SET_COLUMN_FILTER,
        payload: {
            field,
            value
        }
    };
}
exports.setColumnFilter = setColumnFilter;
//# sourceMappingURL=configModal.js.map